<template>
    <div class="control-shape-viever leaflet-control leaflet-bar">
        <a class="fa fa-file-o" title="Ручной ввод координат" @click.stop="addCoordinates" v-if="!editing"></a>
        <a class="fa fa-map-marker" title="Создать маркер" @click.stop="newMarker" v-if="!editing"></a>
        <a class="fa fa-object-group" title="Создать полигон" @click.stop="newPolygon" v-if="!editing"></a>
        <a class="fa fa-object-ungroup" title="Добавить полигон" @click.stop="addPolygon" v-if="editing && !isMarker"></a>
        <a class="fa fa-hand-pointer-o" title="Разрешить перетаскивание" @click.stop="toggleDragging" v-if="editing" v-bind:class="{ active: dragging }"></a>
        <a class="fa fa-trash" title="Очистить" @click.stop="clearLayers" v-if="canDelete"></a>
        <shape-file-uploader @failed="exportError" @complete="showGeojson" @loading="loading"></shape-file-uploader>
    </div>
</template>

<script>
    import ShapeFileUploader from './ShapeFileUploader.vue'
    import Vue from 'vue'
    import _ from 'lodash'

    export default Vue.extend({
        data() {
            return {
                editing: false,
                isMarker: false,
                dragging: false,
                disableSearch: false,
                canDelete: false
            }
        },

        mounted() {
            this.editTools = this.vm.map.editTools;

            window.bus.$on('map:search:query', (query) => {
                if (query && query.geometry) {
                    if (!this.shapeLayer.hasLayer(query.geometry)) {
                        this.showGeojson(query.geometry, query.name);
                    }
                }
            });

            window.bus.$on('map:search:cleared', () => {
                this.disableSearch = true;
                this.shapeLayer.clearLayers();
                this.disableSearch = false;

                window.bus.$emit('map:system:error');
                window.bus.$emit('map:system:notification');
            });

            window.bus.$on('map:system:updatecoordinates', this.updateCoordinates);

            window.bus.$on('map:shapeviewer:create', this.createNewGeometry);

            // Обновление состояние редактирования
            this.editTools.on('editable:enabled', () => this.editing = true);

            this.editTools.on('editable:enable', e => {
                if (this.editTools.currentPolygon) this.editTools.currentPolygon.disableEdit();

                let polygon = this.editTools.currentPolygon = e.layer;
                this.vm.fitLayer = polygon;

                if (polygon.dragging) {
                    if (polygon instanceof L.Marker) {
                        polygon.dragging.enable();
                        this.dragging = true;
                    }
                    else {
                        polygon.dragging.disable();
                    }
                }

                polygon.on('click', function (click) {
                    if (this.editEnabled()) {
                        if (click.originalEvent.ctrlKey) {
                            this.editor.newHole(click.latlng);
                        }
                    }
                });

                if (polygon.showMeasurements) {
                    polygon.on('drag', drag => drag.target.hideMeasurements());
                    polygon.on('dragend', drag => drag.target.showMeasurements().updateMeasurements);
                }

                if (polygon.getLatLng) {
                    this.isMarker = true;
                    polygon.on('drag', drag => this.vm.coordinates = [drag.target.getLatLng()]);
                }

                let latlngs = polygon.getLatLngs ? polygon.getLatLngs() : [polygon.getLatLng()];

                this.vm.coordinates = latlngs;
                this.editTools.fire('editable:enabled');


                window.bus.$emit('map:system:error');
                window.bus.$emit('map:system:notification');
            });

            this.editTools.on('editable:disable', () => {
                this.isMarker = this.dragging = this.editing = false;

                this.vm.coordinates = [];
                this.editTools.currentPolygon.off('click');
                this.editTools.currentPolygon.off('drag');
                this.editTools.currentPolygon.off('dragend');
                delete this.editTools.currentPolygon;

                window.bus.$emit('map:system:error');
                window.bus.$emit('map:system:notification');

                this.sendSearch();
            });

            // Обновление разметки размеров при перемещении точек
            this.vm.map.on('editable:editing', e => {
                if (e.layer.showMeasurements) {
                    e.layer.showMeasurements().updateMeasurements();
                }

                window.bus.$emit('map:system:error');
                window.bus.$emit('map:system:notification');
            });

            // Обновлении списка координат при завершении рисования
            this.vm.map.on('editable:drawing:end', e => {
                if (e.layer.getLatLng) {
                    this.vm.coordinates = [e.layer.getLatLng()];
                }
            });

            // Слой для нарисованных геометрий
            this.shapeLayer = L.featureGroup().addTo(this.vm.map);

            this.shapeLayer.on('layeradd', e => {
                if (e.layer.toggleEdit) e.layer.on('dblclick', L.DomEvent.stop).on('dblclick', e.layer.toggleEdit);
                this.canDelete = this.vm.map.disableOnClick = true;
            });

            this.shapeLayer.on('layerremove', e => {
                if (e.layer.toggleEdit) e.layer.off('dblclick', L.DomEvent.stop).off('dblclick', e.layer.toggleEdit);
                this.canDelete = this.vm.map.disableOnClick = this.shapeLayer.getLayers().length > 0;
            });
        },

        methods: {
            updateCoordinates(coordinates) {
                let layer = this.editTools.currentPolygon;

                if (layer) {
                    if (layer.setLatLngs) {
                        layer.setLatLngs(coordinates);
                    } else {
                        layer.setLatLng(coordinates[0]);
                    }

                    layer.disableEdit();
                    _.delay(() => layer.enableEdit(this.map), 250);
                    window.bus.$emit('map:system:notification', 'Координаты редактируемого объекта изменены');
                } else {
                    layer = (coordinates.length == 1) ? L.marker(coordinates[0]) : L.polygon([coordinates]);

                    if (layer.setStyle) {
                        layer.setStyle(this.shapeStyle);
                    }

                    layer.addTo(this.shapeLayer).disableEdit();
                    layer.enableEdit(this.map);
                    window.bus.$emit('map:system:notification', `Из введенных координат создан новый  ${coordinates.length == 1 ? 'маркер' : 'полигон'}`);

                    this.sendSearch();
                }
            },

            sendSearch(name) {
                if (this.disableSearch) {
                    return;
                }

                if (this.shapeLayer.getLayers().length > 0) {
                    this.vm.search({name: name || 'Векторный объект', geometry: this.shapeLayer});
                    this.vm.fitLayer = this.shapeLayer;
                    this.vm.focus();
                    window.bus.$emit('map:shapeviewer:geometry', this.shapeLayer.toGeoJSON());
                }
                else {
                    this.vm.search();
                    window.bus.$emit('map:shapeviewer:geometry', null);
                }
            },

            clearLayers() {
                this.vm.search();
            },

            addCoordinates() {
                this.vm.coordinates = [L.latLng(0, 0)];
                this.vm.coordinatesVisible = true;
            },

            addPolygon() {
                if (this.editTools.currentPolygon) {
                    this.editTools.currentPolygon.enableEdit();
                    this.editTools.currentPolygon.editor.newShape();
                }
            },

            newPolygon() {
                let polygon = this.editTools.startPolygon().setStyle(this.shapeStyle);
                this.shapeLayer.addLayer(polygon);
                polygon.dragging.disable();
            },

            newMarker() {
                let marker = this.editTools.startMarker();
                this.shapeLayer.addLayer(marker);
                this.dragging = true;
            },

            toggleDragging() {
                let polygon = this.editTools.currentPolygon;

                if (polygon) {
                    if (polygon.dragging.enabled()) {
                        polygon.dragging.disable();
                    }
                    else {
                        polygon.dragging.enable();
                    }
                }

                this.dragging = polygon && polygon.dragging.enabled();
            },

            loading() {
                this.vm.loading = true;
            },

            exportError(error) {
                this.vm.loading = false;
                this.clearLayers();
                window.bus.$emit('map:system:notification');
                window.bus.$emit('map:system:error', error.error || 'При загрузке файла произошла ошибка. Возможно, сервер недоступен или не может обработать запрос');
            },

            showGeojson(geojson, name) {
                this.vm.loading = false;
                this.clearLayers();
                let layers = L.geoJSON(geojson).setStyle(this.shapeStyle);

                for (let layer of this.vm.traverseLayers(layers)) {
                    this.shapeLayer.addLayer(layer);
                }

                this.sendSearch(name);

                window.bus.$emit('map:system:error');
                window.bus.$emit('map:system:notification', 'Выбранный файл загружен на карту');
            },

            createNewGeometry(geojson) {
                this.clearLayers();

                if (geojson) {
                    this.showGeojson(geojson, 'Векторный объект');
                }
                else {
                    this.newPolygon();
                }
            }
        },

        components: { ShapeFileUploader }
    });
</script>

<style scoped>
    a {
        cursor: pointer;
    }

    .active {
        color: #fff;
        background: #555;
    }
</style>


// WEBPACK FOOTER //
// ShapeViewer.vue?23c207b4